// extracted by mini-css-extract-plugin
module.exports = {"canvas":"VenuePlan_canvas__2w-RO"};